var exports = {
  "l": "notice__9vrpdB",
};

module.exports = exports;
